import { InformativeModal } from "../components/modal/Modal";
import type { Component } from "solid-js";
import { MoreAppError } from "../MoreAppError";
import { useTranslation } from "../state/i18n";
import logger from "../utils/logger";

type GenericFailureModalProps = {
  title?: string;
  error: unknown;
};

const resolveDescription = (error: GenericFailureModalProps["error"]): string => {
  const { t } = useTranslation();
  if (error instanceof Error) {
    return t(($) => $.GENERIC_FAILURE_MODAL_DESCRIPTION, { error: error.message });
  }

  logger.error("'GenericFailureModal' received an unknown error", { error });
  return "";
};

const GenericFailureModal: Component<GenericFailureModalProps> = (props) => {
  const { t } = useTranslation();

  return (
    <InformativeModal
      title={props.title ?? t(($) => $.GENERIC_FAILURE_MODAL_TITLE)}
      description={resolveDescription(props.error)}
      inlineMessage={props.error instanceof MoreAppError ? props.error.traceId : undefined}
      confirmLabel={t(($) => $.GENERIC_FAILURE_MODAL_ACTIONS_CONFIRM)}
      closeAriaLabel={t(($) => $.CLOSE_ARIA)}
      onConfirm={() => {
        window.location.reload();
      }}
    />
  );
};

export default GenericFailureModal;
